import Cookies from "js-cookie";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);



const EAE_USER_ID = "eclub-user_id";
const EAE_USER_NAM = "eclub-user_name";
const EAE_USER_ACCOUNT_COUNTRY = "eclub-user_account_country";
const EAE_USER_TYPE = "eclub-user-type";
const TARGET_TYPE = "target_type";
const EAE_USER_EMAIL = "eclub-user_email";
const EAE_SCHOOL_NAME = "eclub-school_name";
const EAE_ACCOUNT_NAME = "eclub-account_name";

export function isAdminLogin() {
    let user_type = getUserType();
    let isAdmin = user_type == "admin" || user_type == "advisor";
    return isAdmin;
}

export function setUserType(user_type) {
    Cookies.set(EAE_USER_TYPE, user_type);
}

export function getUserType() {
    return Cookies.get(EAE_USER_TYPE);
}

export function removeUserType() {
    Cookies.remove(EAE_USER_TYPE);
}

export function setAccountId(account_id) {
    Cookies.set("eclub-account-id", account_id);
}

export function getAccountId() {
    return Cookies.get("eclub-account-id");
}

export function removeAccountId() {
    Cookies.remove("eclub-account-id");
}

export function setUserAccountCountry(country) {
    Cookies.set(EAE_USER_ACCOUNT_COUNTRY, country);
}

export function getUserAccountCountry() {
    return Cookies.get(EAE_USER_ACCOUNT_COUNTRY);
}

export function removeUserAccountCountry() {
    Cookies.remove(EAE_USER_ACCOUNT_COUNTRY);
}

export function setUserId(user_id) {
    Cookies.set(EAE_USER_ID, user_id);
}

export function getUserId() {
    return Cookies.get(EAE_USER_ID);
}

export function removeUserId() {
    Cookies.remove(EAE_USER_ID);
}

export function setUserName(user_name) {
    Cookies.set(EAE_USER_NAM, user_name);
}

export function getUserName() {
    return Cookies.get(EAE_USER_NAM);
}

export function removeUserName() {
    Cookies.remove(EAE_USER_NAM);
}

export function getProjectCode() {
    return "22-23EAE";
}

export function isTestUser() {
    let user_id = getUserId()
    return user_id === "61cd6856a4640b946f8b456f" || user_id === "64b0f34ca4640b167b8b45b2" || user_id === "654de577a4640bc4308b45ee";
}

export function setTargetType(target_type) {
    Cookies.set(TARGET_TYPE, target_type);
}

export function getTargetType() {
    return Cookies.get(TARGET_TYPE);
}

export function setUserEmail(email) {
    Cookies.set(EAE_USER_EMAIL, email);
}

export function getUserEmail() {
    return Cookies.get(EAE_USER_EMAIL);
}

export function removeUserEmail() {
    Cookies.remove(EAE_USER_EMAIL);
}

export function isLoggedIn() {
    return !!getUserId();
}

export function setSchoolName(school_name) {
    Cookies.set(EAE_SCHOOL_NAME, school_name);
}

export function getSchoolName() {
    return Cookies.get(EAE_SCHOOL_NAME);
}

export function removeSchoolName() {
    Cookies.remove(EAE_SCHOOL_NAME);
}

export function setAccountName(account_name) {
    Cookies.set(EAE_ACCOUNT_NAME, account_name);
}

export function getAccountName() {
    return Cookies.get(EAE_ACCOUNT_NAME);
}

export function removeAccountName() {
    Cookies.remove(EAE_ACCOUNT_NAME);
}